import React, { Component } from "react";
import { CardImg, CardTitle } from "reactstrap";
// import { Container, Row, Col } from 'reactstrap';
import { Row, Col } from "antd";
import "./feednews.style.css";
// import { getSandeeNewHelping, getHowGoodChatWithSandee, getAnnouncement } from '../configure/configureFile';
import sandeeUpdate from "../../assets/feednews/sandee_ai.png";
import checkMark from "../../assets/feednews/CheckMark.png";
import { pageConfig } from "../configure/page";
import { getText } from "../configure/utils";
import { LanguageContext } from "../../context/LanguageContext";

// const setStyleBoxSizing = {height:"586px"};
// var session = "";
// var action = "";
// var json;
// var json_csharp;
// var message = "";
// var listenv = [];
// var blockingState = false;
// var lastMessage = false;
// var clickEventExist = false;
// var lambda_api = "";
// var csharp_api = "";
// var showflag = true;
// var v_typeofservice = "";
// var closesender = false;
// var pasteEventNum = 0;
// var clearCloseTyping = false;
// class changeMode extends Component {
//   constructor(props) {
//     super(props);
//   }
//   render() {
//     return (
//       <div style={{ color: "#ccc" }}>
//         <h6>Start Session {this.props.mode}</h6>
//       </div>
//     );
//   }
// }

export default class FeedNews extends Component {
  static contextType = LanguageContext;

  constructor(props) {
    super(props);
    // self = this;
    this.state = {
      sateshowflag: false /*If sateshowflag: = ture It will show widget (For feature if scan QR code it will automatic show gethelp widget )*/,
      // clicked_th: false,
      // clicked_eng: false
      toggleAI: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
      verifyADPass: false,
      preventPaste: false,
    };
    this.menuGenAIClick = this.menuGenAIClick.bind(this);
  }

  menuGenAIClick() {
    // this.setState({ clicked_eng: true });
    // this.setState({ clicked_th: false });
    this.setState({ toggleAI: true, toggleSAPChangeOwner: false,  toggleGetHelp: false,toggleUnlockResetByItOne: false });
    const dfMessenger = document.querySelector("df-messenger");
    const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
    if (dfMessengerBubble) {
      dfMessengerBubble.openChat();
    }
    if (dfMessenger) {
      dfMessenger.startNewSession({ retainHistory: false });
      if (!window.sessionStorage.getItem("dfcx_lang_code")) {
        // setTimeout(() => {
        //   dfMessenger
        //     .querySelector("df-messenger-chat-bubble")
        //     .shadowRoot.querySelector("df-messenger-chat")
        //     .shadowRoot.querySelector("df-messenger-user-input")
        //     .shadowRoot.querySelector(".textarea-wrapper textarea")
        //     .setAttribute("readonly", true);
        // }, 200);

        const start_selectLang = [
          {
            type: "html",
            html: "<b style='font-size:21px'>เลือกภาษา (Select Language)</b>",
          },
        ];
        dfMessenger.renderCustomCard(start_selectLang);
        const thai_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "ภาษาไทย",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(thai_btn);
        const eng_btn = [
          {
            type: "button",
            icon: {
              type: "chevron_right",
              color: "#FF9800",
            },
            mode: "blocking",
            text: "English",
            // event: {
            //   event: "greeting",
            // },
          },
        ];
        dfMessenger.renderCustomCard(eng_btn);
      } else {
        window.addEventListener("df-request-sent", (event) => {
          event.detail.data.requestBody.queryInput.languageCode = window.sessionStorage.getItem("dfcx_lang_code");
          // console.log(JSON.stringify(event.detail.data.requestBody));
        });
        dfMessenger.sendRequest("event", "greeting");
      }
    }
  }

  render() {
    const { getHowGoodChatWithSandee, getAnnouncement } = pageConfig();

    return (
      <div className="cardfeednews">
        <Row className="feedNews athiti-bold">FEED NEWS</Row>
        <Row className="articleStyle">
          <Col lg={{ span: 6 }} xl={{ span: 6 }} xxl={{ span: 4 }}>
            <CardImg src={sandeeUpdate} width={"100%"} className="newUpdate" />
          </Col>
          <Col lg={{ span: 18 }} xl={{ span: 18 }} xxl={{ span: 20 }}>
            <CardTitle className="titleNameStyle athiti-bold">
              <p className="textStyle">
                <div class="blick-button athiti-bold">
                  <b>ASK! SANDEE AI New Feature</b>
                </div>
              </p>
              <p className="newFeatureTextStyle">
                <b>{getText("sandee_helping.head")}</b>
              </p>
              {getText("sandee_helping.content").map((text, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                  <img src={checkMark} alt="checkMark" width={30} />
                  <p className="textStyle">{text}</p>
                </div>
              ))}

              <div className="line"></div>

              <br />

              <p className="newFeatureTextStyle">
                <b>{getText("how_good.head")}</b>
              </p>

              {getHowGoodChatWithSandee().map((item, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center" }}>
                  <img src={item.imgSrc} alt={`icon-${index}`} width={30} />
                  <p className="textStyle">{item.text}</p>
                </div>
              ))}
            </CardTitle>
          </Col>
        </Row>
        {getAnnouncement().map((item, index) => (
          <Row key={index} className="articleStyle">
            <Col lg={{ span: 6 }} xl={{ span: 6 }}>
              <CardImg src={item.imageSrc} width={30} className="imageStyle" />
            </Col>
            <Col lg={{ span: 18 }} xl={{ span: 18 }}>
              <CardTitle className="titleNameStyle athiti-bold">
                {item.title}
                <p className="textStyle">{item.disscription}</p>
                <div className="readMore">
                  <a href={item.href} rel="noopener noreferrer" target="_blank">
                    {item.click}
                  </a>
                </div>
              </CardTitle>
            </Col>
          </Row>
        ))}
      </div>
    );
  }
}
